import { getMessaging, onMessage, getToken } from "firebase/messaging";
import {removeTokenFromServer, sendFCMTokenToServer} from "../database";
import { WorkspaceMember } from "../types";
import {User} from "firebase/auth";

const TOKEN_STORAGE_KEY = "fcm_token"; // Local storage key for caching the FCM token

let messagingInstance: ReturnType<typeof getMessaging> | null = null;

export const initMessaging = async (me: WorkspaceMember) => {
  if (messagingInstance) {
    return messagingInstance;
  }

  const messaging = getMessaging();
  messagingInstance = messaging;
  try {

    // Register the service worker

    const permission = await Notification.requestPermission();

    if (permission !== "granted") {
      console.warn("Notification permission denied.");
      return null;
    }


    // Check for cached token
    const cachedToken = localStorage.getItem(TOKEN_STORAGE_KEY);

    const token = await getToken(messaging, {
      vapidKey: 'BIAEH5Eaqbjj7scD8HTDvSqpxaeC3_YPrcLPB5CKNyCAAMUv1FX3IF2Bkau9TVveWkVwH-bQdesz7hSy3jIDyGI',
    });

    if (token) {
      // Cache the token locally
      localStorage.setItem(TOKEN_STORAGE_KEY, token);

      // Send the token to the server
      await sendFCMTokenToServer(me, token);
     }
    if (cachedToken && token !== cachedToken) {
      await removeTokenFromServer(me.id, cachedToken);
      await sendFCMTokenToServer(me, token);
    }

    return messaging;
  } catch (error) {
    console.error("Error initializing messaging:", error);
    return null;
  }
};

export const clearMessagingCache = async (user: User) => {
  messagingInstance = null;
  const currentToken = localStorage.getItem(TOKEN_STORAGE_KEY);
  localStorage.removeItem(TOKEN_STORAGE_KEY);
  if (currentToken) {
    await removeTokenFromServer(user.uid, currentToken);
  }
};